/**
 * @file This file contains helpers for within the utils package.
 */
/**
 * Create a unique counter.
 *
 * @returns A function that returns a new unique number every time it is called.
 */
export function makeUniqueCounter() {
    let x = 0;
    return () => x++;
}
